import { LocalStorage } from "@pentacode/app/src/lib/storage";
import { PentacodeAPIClient } from "@pentacode/rest";
import type { ReactiveController, ReactiveControllerHost } from "lit";
import { PUBLIC_PTC_REST_URL } from "../env";
import { TimeLogger } from "../lib/time_logger";

const client = new PentacodeAPIClient(`${PUBLIC_PTC_REST_URL || "https://localhost:3005/rest/v1"}` as any);
const logger: TimeLogger = new TimeLogger(client, new LocalStorage());
void logger.init();

export class TimeLogController implements ReactiveController {
    get state() {
        return logger.state;
    }

    get logger() {
        return logger;
    }

    get client() {
        return client;
    }

    private _host: ReactiveControllerHost;
    private _intervalHandle: number | NodeJS.Timeout | undefined;

    public currentTime = new Date();

    constructor(host: ReactiveControllerHost) {
        (this._host = host).addController(this);

        void logger.loaded.then(() => {
            const loadingScreen = document.querySelector(".loading-screen");
            loadingScreen?.setAttribute("aria-busy", "false");
        });
    }

    private _requestUpdate = () => this._host.requestUpdate();

    private _poll = () => this.logger.poll();

    private _pollIfVisible = () => {
        if (!document.hidden) {
            this.logger.poll();
        }
    };

    hostConnected() {
        logger.subscribe(this._requestUpdate);
        window.addEventListener("online", this._poll);
        document.addEventListener("visibilitychange", this._pollIfVisible);
        this._intervalHandle = setInterval(() => {
            const now = new Date();
            const truncatedNow = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                now.getHours(),
                now.getMinutes()
            );

            //update current time with minute accuracy
            if (this.currentTime.getTime() !== truncatedNow.getTime()) {
                this.currentTime = truncatedNow;
                this._host.requestUpdate();
            }
        }, 1000);
    }
    hostDisconnected() {
        logger.unsubscribe(this._requestUpdate);
        window.removeEventListener("online", this._poll);
        document.removeEventListener("visibilitychange", this._pollIfVisible);
        clearInterval(this._intervalHandle);
    }
}
